__webpack_require__.p = "//givsum-staging.s3.amazonaws.com/packs/";